import { Nullable, OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { ResourceTypeData } from '../Types/ResourceTypeData'
import { ResourceTypeDto } from '../Types/ResourceTypeDto'
import { ResourceTypeApiAdapter } from '../Adapters/ResourceTypeApiAdapter'

export default class ClvrResourceType {
    public id: Nullable<number> = null
    public label = ''

    public constructor(data?: ResourceTypeData) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public static convertDtoToResourceTypeList(refResourceTypes?: OneOrMore<ResourceTypeDto>): ClvrResourceType[] {
        if (refResourceTypes) {
            return Array.isArray(refResourceTypes)
                ? refResourceTypes.map(new ResourceTypeApiAdapter().createClass)
                : [new ResourceTypeApiAdapter().createClass(refResourceTypes)]
        }
        return []
    }

    public toDto(): ResourceTypeDto {
        return {
            id: this.id,
            label: this.label,
        }
    }
}
